import ReleaseDisclaimer from "./ReleaseDisclaimer"
import VolunteerCodeOfConduct from './VolunteerCodeOfConduct'
import Photography from './Photography'

export const BuddyConsentReleaseDisclaimer = ReleaseDisclaimer
export const BuddyConsentVolunteerCodeOfConduct = VolunteerCodeOfConduct
export const BuddyConsentPhotography = Photography